<template lang="pug">
  .ugc-banner.container
    .row
      .title-wrap.xs-12.text-center
        p.ugc-title.xs-f-xlarge.sm-f-xxxlarge.md-f-grande.max-at-tweak Real people, real<br/> gorgeous hair color

      .photo-banner.xs-12
        .photos-wrap(ref="photosWrap")
          .photo.a-box-xs-1x1(v-for="(id, index) in mediaIds" :key="index + '_1'" :class="{first: index == 0}")
            .a-box-content
              img-box(:media-id="id")

          .photo.a-box-xs-1x1(v-for="(id, index) in mediaIds" :key="index + '_2'")
            .a-box-content
              img-box(:media-id="id")

</template>

<script>
  export default {
    name: "UGCBanner",

    data() {
      return {
        mediaIds: [6147, 6146, 6145, 6144, 6143, 6142, 6141, 6140, 6139, 6138, 6137, 6136, 6135, 6134]
      }
    }
  }
</script>

<style scoped lang="stylus">
  .ugc-banner
    overflow hidden
    margin 0 auto
    padding 0 0 3em 0
    background-color #ffffff
    
    .ugc-title
      margin 1.5em auto 1.2em auto
    
    .photo-banner
      height 200px
      width 5600px
      animation bannermove 80s linear infinite
      
      .photo
        transition all 0.5s ease
        width 200px !important  
        height 200px !important
        padding 0 !important
        display inline-block
        vertical-align top
        white-space nowrap      

    @media mq-tablet-plus
      @keyframes bannermove
        0%
          margin-left 0px
      
        100%
          margin-left -2800px
     
    @media mq-mobile
     .photo-banner
        height 135px
        width 3780px
        
        img
          transition all 0.5s ease
          width 135px !important  
          height 135px !important
          padding 0 !important
    
      .first
        animation bannermove 80s linear infinite
     
      @keyframes bannermove
        0%
          margin-left 0px
      
        100%
          margin-left -1890px
</style>
